<mat-toolbar>
  <a (click)="resetFlow()" routerLink="/" aria-label="Home">
    <img class="logo" src="assets/images/logo.svg" alt="Company Logo" />
  </a>
</mat-toolbar>
